<!-- eslint-disable vue/no-parsing-error -->
<template>
  <!-- skeleton -->
  <PlaySkeleton :show="secondContentLoading" />

  <div class="play-wrapper" v-if="!secondContentLoading">
    <div class="play-content">
      <div class="video-box">
        <div class="video-wrap">
          <Xg-Player2
            :id="'xgPlayer'"
            v-model:datas="videoDatas"
            :init="true"
            :autoplay="true"
          />
        </div>
      </div>
      <!-- tab标签 -->
      <div class="tabs-box">
        <van-tabs
          title-inactive-color="#999999"
          title-active-color="#222222"
          color="#0F3CC6"
          :ellipsis="false"
        >
          <van-tab
            :title="item.name"
            v-for="(item, index) in lists"
            :key="index"
          >
          </van-tab>
        </van-tabs>
      </div>
    </div>
    <div class="tab-wrap">
      <!-- 视频 -->
      <div class="tab-box course-item-box">
        <div v-if="videoList.length">
          <div
            class="video-item-title"
            v-for="(item, index) of videoList"
            @click="updateCurrentClick(item, index)"
            :key="index"
          >
            <div class="title-left-cion" v-if="videoActiveIndex == item.id">
              <van-image
                :src="require('@/assets/H5/play/live-icon.png')"
                alt=""
              />
            </div>
            <div
              class="title ellipsis-line-2"
              :class="videoActiveIndex == item.id ? 'active' : ''"
            >
              {{ item.name }}
            </div>
            <div class="score-box" @click.stop="toScore(item)">
              <span v-if="item.score" style="color: red">
                {{ item.score.totalScore }}分
              </span>
              <span v-else class="text"> 评分 </span>
            </div>
          </div>
        </div>
        <div v-else>
          <van-empty description="" />
        </div>
      </div>
    </div>
  </div>

  <van-popup
    v-model:show="showPopup"
    position="right"
    :style="{ width: '100vw', height: '100vh' }"
  >
    <div class="popup-page">
      <div class="popup-title">国家基层儿科医护人员培训项目科普视频评分表</div>
      <div class="popup-tip">
        <div class="count-name">{{ countVideo.name }}</div>
        <div class="van-hairline--top"></div>
        <div class="tip-title">建议评分标准:</div>
        <div>
          内容科学性（30分） 表现形式创新性（30分） <br />
          传播力与感染力（20分）作品表现力（20分）
        </div>
      </div>
      <div class="score-content">
        <div class="score-item">
          <div class="label">内容科学性（30分）:</div>
          <div class="value">
            <van-field
              type="digit"
              autocomplete="off"
              placeholder="请输入分数"
              v-model="score.contentScientificity"
            />
          </div>
        </div>
        <div class="score-item">
          <div class="label">表现形式创新性（30分）:</div>
          <div class="value">
            <van-field
              type="digit"
              autocomplete="off"
              placeholder="请输入分数"
              v-model="score.innovation"
            />
          </div>
        </div>
        <div class="score-item">
          <div class="label">传播力与感染力（20分）:</div>
          <div class="value">
            <van-field
              type="digit"
              autocomplete="off"
              placeholder="请输入分数"
              v-model="score.influence"
            />
          </div>
        </div>
        <div class="score-item">
          <div class="label">作品表现力（20分）:</div>
          <div class="value">
            <van-field
              type="digit"
              autocomplete="off"
              placeholder="请输入分数"
              v-model="score.expressiveness"
            />
          </div>
        </div>
        <div class="score-item">
          <div class="label">总分:</div>
          <div class="value" style="color: red">
            {{ totalScore }}
          </div>
        </div>
      </div>
      <div class="score-name">
        <div>评审人姓名：</div>
        <div class="value">
          <van-field
            autocomplete="off"
            placeholder="请输入评审人姓名"
            v-model="score.expertName"
          />
        </div>
      </div>
      <div class="score-btn">
        <van-button type="primary" class="btn-cancel" @click="closePupop">
          关闭
        </van-button>
        <van-button
          type="primary"
          :loading="loading"
          loading-text="提交中..."
          class="btn-submit"
          @click="submitScore"
        >
          提交评分
        </van-button>
      </div>
    </div>
  </van-popup>
</template>

<script setup>
import { scoreplayApi, scoresubmitApi } from "@/api/play";
import { ref, onMounted, watch, computed } from "vue";
import { useRoute } from "vue-router";
import { Toast } from "vant";
import PlaySkeleton from "@/components/H5/skeleton/PlaySkeleton";
import XgPlayer2 from "@/components/H5/play/XgPlayer2.vue";
const route = useRoute();
const videoBanner = ref("");
const videoDatas = ref({});
const secondContentLoading = ref(true);
const lists = ref([
  {
    name: "国家基层儿科医护人员培训项目科普视频",
    key: 1,
  },
]);

const zhuanlanId = ref("");
onMounted(() => {
  zhuanlanId.value = route.query.id;
  getSpecialDetailFun();
});
let videoActiveIndex = ref(-1);
const videoList = ref([]);
const getSpecialDetailFun = async () => {
  try {
    const { results } = await scoreplayApi(zhuanlanId.value);
    videoList.value = results.videoList || [];
    videoBanner.value = results.banner;
    secondContentLoading.value = false;
    if (videoList.value.length) {
      videoActiveIndex.value = videoList.value[0].id;
      videoDatas.value = {
        content: videoList.value[0].content,
        id: videoList.value[0].id,
        poster: videoList.value[0].banner,
        banner: videoList.value[0].banner,
      };
    }
  } catch (e) {
    console.log(e);
  }
};

const updateCurrentClick = (clickObj) => {
  if (videoDatas.value.id === clickObj.id) {
    return;
  }
  videoActiveIndex.value = clickObj.id;
  videoDatas.value = {
    content: clickObj.content,
    id: clickObj.id,
    poster: clickObj.banner,
    banner: clickObj.banner,
  };
};

const showPopup = ref(false);
const countVideo = ref(null);
const toScore = (item) => {
  countVideo.value = item;
  if (item.scoreRecord) {
    score.value = JSON.parse(JSON.stringify(item.scoreRecord));
    score.value.expertName = item.score.expertName || "";
  } else {
    initScord();
  }
  showPopup.value = true;
};

const closePupop = () => {
  showPopup.value = false;
};

const initScord = () => {
  score.value.contentScientificity = undefined;
  score.value.innovation = undefined;
  score.value.expressiveness = undefined;
  score.value.influence = undefined;
  score.value.totalScore = 0;
  score.value.videoName = "";
};
const score = ref({
  contentScientificity: undefined,
  innovation: undefined,
  expressiveness: undefined,
  influence: undefined,
  expertName: "",
  totalScore: 0,
  videoName: "",
});

// 实时计算总分
const totalScore = computed(() => {
  return (
    Number(score.value.contentScientificity || 0) +
    Number(score.value.innovation || 0) +
    Number(score.value.influence || 0) +
    Number(score.value.expressiveness || 0)
  );
});

const buildParams = () => {
  const s = score.value;
  const scoreJsonObj = {
    内容科学性: s.contentScientificity,
    表现形式创新性: s.innovation,
    传播力与感染力: s.influence,
    作品表现力: s.expressiveness,
  };

  return {
    videoOrder: countVideo.value.id,
    expertName: s.expertName,
    contestCode: "国培儿科-上海站",
    totalScore: totalScore.value,
    scoreJson: scoreJsonObj,
    videoName: countVideo.value.name,
  };
};

const scoresubmit = async () => {
  try {
    let params = buildParams();
    await scoresubmitApi(params);
    countVideo.value.score = params;
    countVideo.value.scoreRecord = JSON.parse(JSON.stringify(score.value));
    Toast.success("提交成功");
    loading.value = false;
    showPopup.value = false;
  } catch (e) {
    console.log(e);
    loading.value = false;
  }
};

const loading = ref(false);
const submitScore = () => {
  if (!score.value.expertName) {
    Toast("请填写评审人姓名");
    return;
  }
  loading.value = true;
  scoresubmit();
};

watch(
  () => score.value.contentScientificity,
  (v) => {
    if (v === "" || v === null) return;

    score.value.contentScientificity = Math.min(30, Math.max(0, Number(v)));
  }
);
watch(
  () => score.value.innovation,
  (v) => {
    if (v === "" || v === null) return;
    score.value.innovation = Math.min(30, Math.max(0, v));
  }
);
watch(
  () => score.value.expressiveness,
  (v) => {
    if (v === "" || v === null) return;
    score.value.expressiveness = Math.min(20, Math.max(0, v));
  }
);
watch(
  () => score.value.influence,
  (v) => {
    if (v === "" || v === null) return;
    score.value.influence = Math.min(20, Math.max(0, v));
  }
);
</script>

<style lang="less" scoped>
.arrow-left {
  font-size: 18px !important;
}
.over-page {
  overflow: hidden;
}
.play-wrapper {
  box-sizing: border-box;
  height: 100vh;
  // padding-bottom: 50px;
  background: #ffffff;
  display: flex;
  flex-direction: column;
  :deep(.van-popup) {
    .van-picker {
      .van-picker__confirm {
        color: #0f3cc6;
      }
    }
  }
  .play-content {
    height: 250px;
    flex-shrink: 0;
  }
  .tab-wrap {
    overflow-y: auto;
  }
  .flex {
    display: flex;
  }

  .flex-a-c {
    align-items: center;
  }

  .flex-j-c {
    justify-content: center;
  }

  .flex-j-b {
    justify-content: space-between;
  }

  // top-视频
  .video-box {
    background: #ffffff;
    position: relative;

    .video-wrap {
      height: 212px;
      position: relative;
      .video {
        width: 100%;
        height: 212px;
      }
    }

    .content {
      padding: 14px 16px 16px 16px;

      .title {
        font-size: 14px;
        font-weight: 500;
        color: #212224;
        line-height: 20px;
        .sc {
          align-items: start;
          flex-shrink: 0;
          margin-left: 24px;
          margin-top: 3px;
          .icon {
            width: 12px;
            height: 12px;
            margin-right: 4px;
            background: url(./../../assets/H5/play/icon-sc.png) no-repeat 0 0;
            background-size: contain;
            margin-top: 3px;
          }
          .sc-text {
            font-weight: 400;
            font-size: 12px;
            color: #999999;
            line-height: 18px;
          }
          &.active {
            .icon {
              background: url(./../../assets/H5/play/icon-sc-ed.png) no-repeat 0
                0;
              background-size: contain;
            }
            .sc-text {
              color: #feb432;
            }
          }
        }
      }
    }
  }
  .mt8 {
    margin-top: 8px;
  }
  .tabs-box {
    border-bottom: 1px solid #f7f7f7;
  }
  // 页签-item
  .tab-box {
    padding: 10px 16px;
    // 图文
    &.tuwen-item-box {
      /deep/ img {
        max-width: 100%;
      }
    }
  }
}
.sticky-navbar {
  position: sticky;
  top: 0;
}
.float-navbar {
  position: absolute;
  margin-top: 6px;
  margin-left: 11px;
  width: 32px;
  height: 32px;
  z-index: 999;
  .left-img {
    width: 32px;
    height: 32px;
  }
}

.video-item-title {
  margin-bottom: 12px;
  display: flex;
  justify-content: space-between;
  align-items: start;
  // height: 44px;
  padding: 11px 12px;
  background: #f7f7f7;
  border-radius: 4px;
  .title-left-cion {
    width: 16px;
    height: 22px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 8px;
    .van-image {
      width: 16px;
      height: 16px;
    }
  }
  .title {
    flex: 1;
    margin-right: 16px;
    font-size: 13px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #222;
    line-height: 22px;
  }
  .title.active {
    color: #0f3cc6;
    // margin-right: 8px;
  }
  .show-icon-box {
    height: 22px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .show-icon {
    width: 12px;
    height: 12px;
  }
  .score-box {
    .text {
      background-color: #0f3cc6;
      padding: 2px 4px;
      border-radius: 4px;
      font-size: 12px;
      font-weight: 400;
      color: #fff;
      line-height: 18px;
    }
  }
}

.popup-page {
  min-height: 100vh;
  padding: 16px;
  box-sizing: border-box;
  background: #f7f8fa;
}

/* 标题 */
.popup-title {
  font-size: 18px;
  font-weight: 600;
  color: #323233;
  text-align: center;
  line-height: 1.4;
  margin-bottom: 14px;
}

/* 提示说明 */
.popup-tip {
  background: #ffffff;
  border-radius: 8px;
  padding: 12px;
  color: #646566;
  line-height: 1.6;
  margin-bottom: 16px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  .count-name {
    color: #000000;
    font-size: 15px;
  }
  .tip-title {
    margin-top: 10px;
  }
}

/* 评分区 */
.score-content {
  background: #ffffff;
  border-radius: 8px;
  padding: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
}

/* 单条评分 */
.score-item {
  display: flex;
  flex-direction: column;
  margin-bottom: 12px;
  gap: 5px;
}

.score-item:last-child {
  margin-bottom: 0;
}

/* 左侧文字 */
.score-item .label {
  flex: 1;
  font-size: 14px;
  color: #323233;
  line-height: 1.4;
}

/* 右侧输入 */
.score-item .value {
  width: 96px;
}

/* van-field 美化 */
.score-content .van-field {
  background: #f7f8fa;
  border-radius: 6px;
  padding: 0 6px;
}

.score-name .van-field {
  text-align: center;
  font-size: 14px;
  background: #f7f8fa;
  height: 30px;
  padding: 0 6px;
}

/* 评审人 */
.score-name {
  margin-top: 16px;
  background: #ffffff;
  border-radius: 8px;
  padding: 12px;
  display: flex;
  align-items: center;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
}

.score-name .label {
  font-size: 14px;
  color: #323233;
  margin-right: 8px;
  white-space: nowrap;
}

.score-name .value {
  flex: 1;
}

/* 按钮 */
.score-btn {
  margin-top: 20px;
  display: flex;
  gap: 12px;
}

.btn-cancel {
  flex: 1;
  background: #f2f3f5;
  color: #646566;
  border-radius: 10px;
  font-size: 15px;
  height: 44px;
}

.btn-submit {
  flex: 1;
  background: #1989fa;
  color: #ffffff;
  border-radius: 10px;
  font-size: 15px;
  height: 44px;
  box-shadow: 0 4px 10px rgba(25, 137, 250, 0.2);
}
</style>
<style lang="less">
.xgplayer-start,
.xgplayer-loading {
  width: 40px !important;
  height: 40px !important;
  margin: -20px auto auto -20px !important;
  svg {
    width: 40px;
    height: 40px;
  }
}

.xgplayer-replay {
  svg {
    width: 40px;
    height: 40px;
  }
}

.xgplayer-enter-spinner {
  width: 40px !important;
  height: 40px !important;
}
.zbqd-dialog {
  padding: 20px;
  .text-box {
    padding: 50px;
    text-align: center;
    font-size: 16px;
  }
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.fade-enter-from {
  opacity: 0;
}

#launch-btn {
  width: 100% !important;
  height: 100% !important;
  display: block;
}
</style>
